import { AnyAction } from '@reduxjs/toolkit';

// Usual actions are CRUD
export const UPDATE_NETWORK = 'network/update';
export const TOGGLE_NETWORK = 'network/toggle';

export type NetworkPayload = {
	status: boolean;
};

export type NetworkReducerAction = {
	type: string;
	payload: NetworkPayload;
};

const initialState: NetworkPayload = {
	status: true,
};

export function updateNetwork(new_status: boolean) {
	return {
		type: UPDATE_NETWORK,
		payload: {
			status: new_status,
		} as NetworkPayload,
	};
}

export default function networkReducer(
	state = initialState,
	action: AnyAction,
) {
	switch (action.type) {
		case UPDATE_NETWORK: {
			// Omit actual code
			state = {
				status: action.payload.status,
			};
			return state;
		}
		case TOGGLE_NETWORK: {
			state = {
				status: !state.status,
			};
			return state;
		}
		default:
			return state;
	}
}
